const isStringifiedNumber = (val) => {
    const coercedVal = +val;
    return typeof coercedVal === 'number' && Number.isFinite(coercedVal);
};
export default isStringifiedNumber;
//# sourceMappingURL=index.js.map